import {
  editorialErrorCodeToErrorMessageMapping,
  editorialErrorCodeToReasonMessageMapping,
  editorialPublisherCountryMapping,
} from '@bingads-webui-campaign/api-errors';

const deliveryStatus = {
  Message_DeliveryStatus_Eligible: _TL_('Eligible'),
  Message_DeliveryStatus_AssetGroupExpired: _TL_('No ads are running for this asset group because the asset group has expired.\r\nTo continue running ads for this asset group, click on the end date to edit it. Choose a new end date and then click Save.'),
  Message_DeliveryStatus_AssetGroupUserPaused: _TL_('You have paused this asset group, so no ads are running. To start running your ads, go to the Asset Groups tab, select the check box for this asset group, and then on the Edit menu, click Enable.'),
  Message_DeliveryStatus_CampaignUserPaused: _TL_('You have paused this campaign, so no ads are running. To start running your ads, go to the Campaigns tab, select the check box for this campaign, and on the Edit menu, click Enable.'),
  Message_DeliveryStatus_CampaignBudgetPaused: _TL_("No ads are running for this campaign because you've used up your budget.\r\nTo fix it, on the Campaigns tab, click on the budget amount to edit it. Increase your budget amount and click Save."),
  Message_DeliveryStatus_CampaignSuspended: _TL_('Your campaign has been suspended and no ads are eligible for delivery because of suspicious activity. Please contact <a href="http://go.microsoft.com/fwlink/?LinkId=506728">Microsoft Advertising support</a>.'),
  Message_DeliveryStatus_CampaignInProgress: _TL_('This campaign\'s setup is not complete. Click the campaign name to return to the setup process.'),
  Message_DeliveryStatus_ShoppingCampaignStoreNotFound: _TL_("This campaign's store cannot be found. Go to Microsoft Merchant Center to make sure that the associated store is active and contains approved offers."),
  Message_DeliveryStatus_ShoppingCampaignNoOffersPresent: _TL_("This campaign's product offers cannot be found. Go to Microsoft Merchant Center to make sure that the associated store contains approved offers."),
  Message_DeliveryStatus_ShoppingCampaignNoOffersPresent_With_Link: _TL_("This campaign's product offers cannot be found. Go to <a href={{actionLink}} target='_blank'>Microsoft Merchant Center</a> to make sure that the associated store contains approved offers. <a class='HelpTopic' query='app54824' href='javascript:void(0);'>Learn more</a>"),
  Message_DeliveryStatus_InvalidFinancialStatusOther: _TL_('All of your ads have stopped running because we couldn’t bill your account. To fix it, go to the Accounts & Billing tab and check that your credit card is not expired.'),
  Message_DeliveryStatus_EditorialApprovedLimited: _TL_('Eligible for delivery, but not in all publisher countries/regions.'),
  Message_DeliveryStatus_EditorialApprovedLimitedAppealRejected: _TL_('Eligible for delivery, but not in all publisher countries/regions.'),
  Message_DeliveryStatus_EditorialRejected: _TL_('Disapproved'),
  Message_DeliveryStatus_EditorialAppealRejected: _TL_('Disapproved, exception denied'),
  Message_DeliveryStatus_EditorialUnderAppeal: _TL_("This asset group is not running while it's under review for an exception. Most reviews are completed within one business day."),
  Message_DeliveryStatus_EditorialPending: _TL_('This asset group is not running because it is still pending editorial review. Most reviews are completed within one business day.'),
  Message_DeliveryStatus_ReadyForAudienceCampaignNotSearchCampaign: _TL_('Ready for audience campaigns, but too small for search campaigns'),
  Message_DeliveryStatus_ReadyForSearchCampaignNotAudienceCampaign: _TL_('Ready for search campaigns, but too small for audience campaigns'),
};

const deliveryStatusDetails = {
  Contact_Support: _TL_('Contact support'),

  DeliveryStatus_Violcation_Country: _TL_('Not allowed in {0} countries/regions'),
  DeliveryStatus_Violcation_Location: _TL_('Violation in {0}'),
  DeliveryStatus_Violcation_One_Country: _TL_('Not allowed in {0}'),
  DeliveryStatus_Violcation_Country_WithLink: _TL_('Not allowed in {{tag}}{{number}} countries/regions{{endtag}}'),

  EditorialAppeal_ThisEntity: _TL_('this {0}'),

  EdReason_Ad: _TL_('Ad'),
  EdReason_AdDesc: _TL_('Ad Text'),
  EdReason_AdDestUrl: _TL_('Destination URL'),
  EdReason_AdTitle: _TL_('Ad Title'),
  EdReason_AdTitleDesc: _TL_('Ad Title Description'),
  EdReason_AltText: _TL_('Alternate text'),
  EdReason_Asset: _TL_('Asset'),
  EdReason_Association: _TL_('Association'),
  EdReason_Audio: _TL_('Audio'),
  EdReason_BusinessName: _TL_('Business Name'),
  EdReason_CAsset: _TL_('CAsset'),
  EdReason_DataFeedItem: _TL_('Feed item'),
  EdReason_DisplayUrl: _TL_('Display URL'),
  EdReason_Flash: _TL_('Flash'),
  EdReason_Image: _TL_('Image'),
  EdReason_Keyword: _TL_('Keyword'),
  EdReason_LandingUrl: _TL_('Landing Page'),
  EdReason_Order: _TL_('Ad Group'),
  EdReason_OrderItem: _TL_('Keyword'),
  EdReason_Param1: _TL_('Param1'),
  EdReason_Param2: _TL_('Param2'),
  EdReason_Param3: _TL_('Param3'),
  EdReason_PhoneNumber: _TL_('Phone Number'),
  EdReason_Script: _TL_('Script'),
  EdReason_SiteDomain: _TL_('Website'),
  EdReason_Video: _TL_('Video'),

  EntityStatus_ApprovedLimited: _TL_('Approved limited'),
  EntityStatus_Pending: _TL_('Inactive'),
  EntityStatus_Rejected: _TL_('Disapproved'),

  NoRejectionReasonFound: _TL_('No rejection data is available at this time. Please try again later.'),

  Request_Another_Review: _TL_('to request another review'),

  Request_Exception: _TL_('Request an exception for {0}'),
  RejectionCountriesText: _TL_('Countries/Regions:'),
};

const pagination = {
  Grid_NextPage: _TL_('Next page'),
  Grid_Page_Colon: _TL_('Page:'),
  Grid_Page_Number: _TL_('Page number'),
  Grid_Page_Number_Label_Text: _TL_('Page:'),
  Grid_Page: _TL_('Page'),
  Grid_PageOf: _TL_('of'),
  Grid_PreviousPage: _TL_('Previous page'),
};

export const legacyI18nKeys = [
  deliveryStatus,
  deliveryStatusDetails,
  editorialErrorCodeToErrorMessageMapping,
  editorialErrorCodeToReasonMessageMapping,
  editorialPublisherCountryMapping,
  pagination,
];
